import { render, staticRenderFns } from "./Reasons.vue?vue&type=template&id=5078edb7&scoped=true&"
import script from "./Reasons.vue?vue&type=script&lang=js&"
export * from "./Reasons.vue?vue&type=script&lang=js&"
import style0 from "./Reasons.vue?vue&type=style&index=0&id=5078edb7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5078edb7",
  null
  
)

export default component.exports